<template>
  <span class="logo-animated-v">
    <svg
      width="347"
      height="297"
      viewBox="0 0 347 297"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M104.908 287.445C105.998 290.341 107.903 292.736 110.294 294.381C112.697 296.013 115.587 297 118.647 297H236.482C239.544 297.004 242.53 296.047 245.022 294.266C247.514 292.484 249.387 289.966 250.379 287.064L346.541 10.937C346.976 9.69116 347.105 8.35831 346.915 7.05209C346.725 5.74587 346.223 4.50502 345.451 3.43533C344.692 2.36676 343.686 1.49766 342.52 0.901915C341.353 0.306173 340.061 0.00140269 338.752 0.013522H244.994C242.318 0.0163274 239.717 0.894342 237.585 2.51407C235.451 4.13344 233.886 6.39231 233.12 8.96286L181.499 176.842C181.013 178.369 179.423 179.079 177.847 179.079C176.271 179.079 174.747 178.263 174.301 176.789L119.79 8.58121C118.998 6.0843 117.434 3.90434 115.324 2.35614C113.227 0.812962 110.689 -0.0129995 108.087 0.000362202H8.31285C6.9758 -0.012189 5.6558 0.301631 4.46691 0.914711C3.27802 1.52779 2.25601 2.42169 1.48914 3.51918C0.722274 4.61666 0.233618 5.88473 0.0654213 7.21381C-0.102775 8.5429 0.0545244 9.89303 0.523744 11.1476L104.895 287.432L104.908 287.445Z"
        fill="#00FFE0"
      />
    </svg>
  </span>
</template>
<script setup lang="ts"></script>

<style scoped lang="postcss">
.logo-animated-v {
  display: inline-block;

  > svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
